import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancelled() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const reservationId = params.get('reservation_id');

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        <XCircle className="w-16 h-16 text-[#C4A962] mx-auto mb-6" strokeWidth={1.5} />
        <h1 className="font-['Playfair_Display'] text-3xl text-[#2C3E30] mb-3">Paiement annule</h1>
        <p className="text-[#595959] mb-8">
          Votre paiement a ete annule. Votre reservation est en attente.
          Vous pouvez reprendre le paiement a tout moment.
        </p>
        <div className="flex flex-col gap-3">
          <Button
            data-testid="retry-payment-btn"
            onClick={() => navigate('/#reservation')}
            className="rounded-full px-8 bg-[#8A9A5B] text-white hover:bg-[#7a8a4d]"
          >
            Reprendre la reservation
          </Button>
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="rounded-full px-8 border-[#E5E5E0]"
          >
            <ArrowLeft className="w-4 h-4 mr-2" strokeWidth={1.5} /> Retour au site
          </Button>
        </div>
      </div>
    </div>
  );
}
